import React, { useEffect, useState } from "react";
import { Check, Loader2, Pencil, X } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export const CycleTitleEditor = ({ cycle, fallback, onSaved }) => {
  const title = cycle?.name || (cycle ? `Ciclo Live #${cycle.cycle_number}` : fallback);
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(title);
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (!editing) setValue(title); }, [title, editing]);

  const save = async () => {
    const name = value.trim();
    if (!name) return toast.error("Informe um título para o ciclo.");
    if (name === title) return setEditing(false);
    setSaving(true);
    try {
      await api.patch(`/api/live-cycles/${cycle.id}/name`, { name });
      toast.success("Título do ciclo atualizado.");
      setEditing(false);
      onSaved?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível salvar o título.");
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <div className="flex items-center gap-2 my-1">
        <input data-testid="cycle-title-input" autoFocus value={value} maxLength={120}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
          className="flex-1 min-w-0 bg-[#0F1218] border border-[#FF6B00] rounded-lg px-3 py-1.5 text-white text-lg font-extrabold focus:outline-none" />
        <button data-testid="cycle-title-save-btn" onClick={save} disabled={saving}
          className="w-9 h-9 shrink-0 rounded-lg bg-[#FF6B00] text-black flex items-center justify-center disabled:opacity-60">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
        </button>
        <button data-testid="cycle-title-cancel-btn" onClick={() => setEditing(false)}
          className="w-9 h-9 shrink-0 rounded-lg bg-[#1F2330] border border-[#3E4760] text-gray-300 flex items-center justify-center">
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <h1 data-testid="cycle-title" className="group text-xl sm:text-2xl font-extrabold text-white flex items-start gap-2">
      <span className="break-words min-w-0">{title}</span>
      {cycle && (
        <button data-testid="cycle-title-edit-btn" onClick={() => setEditing(true)} title="Editar título do ciclo"
          className="mt-1 shrink-0 p-1 rounded-md text-gray-500 hover:text-[#FF6B00] hover:bg-[#1F2330] transition-colors">
          <Pencil className="w-4 h-4" />
        </button>
      )}
    </h1>
  );
};
